/**
 * Auth domain routes
 */
export const authRoutes = {
  login: '/login',
  loginCallback: '/login/callback',
  notFound: '/not-found',
};

/**
 * Helper function to get route paths without leading slash
 * Used for router configuration
 */
export const getAuthRoutePaths = () => ({
  login: authRoutes.login.substring(1), // Remove leading slash
  loginCallback: authRoutes.loginCallback,
  notFound: authRoutes.notFound.substring(1),
});
